export default {"src":"/_next/static/image/public/images/ic_plus_grey.05fac11c3b7ef59327aa5eda94a166a6.svg","height":16,"width":16};